import mediaQueries from "../styles/media-queries";
import icons from "../imgs/icons";

const bottleContainer = method => {
  return {
    textAlign: "center",
    margin: "0 auto",
    overflow: "hidden",
    position: "relative"
  };
};

const bottle = method => {
  return {
    maxWidth: method === "redirect" ? "100%" : "200px",
    maxHeight: method === "redirect" ? "60vh" : "60vh",
    transition: "none"
  };
};

const total = {
  fontFamily: "JWSansBook",
  fontSize: "14px",
  color: "#000000",
  letterSpacing: "1px",
  lineHeight: 1.2,
  textAlign: "center",
  margin: 0,
  [mediaQueries.tablet]: {
    fontSize: "16px",
    letterSpacing: "0.5px",
    lineHeight: "24px"
  }
};

const price = {
  fontFamily: "JWSansBold",
  color: "#000000",
  textAlign: "center",
  display: "block",
  fontSize: "24px",
  lineHeight: "30px",
  letterSpacing: "5px",
  [mediaQueries.tablet]: {
    fontSize: "30px",
    lineHeight: "46px"
  }
};

const zoomButtons = {
  width: "42px",
  height: "42px",
  border: "none",
  cursor: "pointer",
  position: "absolute",
  top: "70%",
  padding: 0,
  transform: "translateY(-50%)",
  zIndex: 1,
  display: "none",
  [mediaQueries.desktop]: {
    display: "block"
  },
  ":focus": {
    outline: "none"
  }
};

const zoomIn = {
  ...zoomButtons,
  background: `url(${icons.zoomInIcon}) no-repeat`,
  backgroundSize: "100%",
  right: "25%"
};

const zoomOut = {
  ...zoomButtons,
  background: `url(${icons.zoomOutIcon}) no-repeat`,
  backgroundSize: "100%",
  left: "25%"
};

const pinchIcon = {
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  height: "55px",
  width: "55px",
  right: "10%",
  transition: "opacity 0.3s linear"
};

const labelImageWrapper = {
  height: "45px",
  width: "45px",
  position: "relative"
};

const labelImage = {
  maxHeight: "100%",
  maxWidth: "100%",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
};

const labelCanvas = {
  position: "absolute",
  top: "50%",
  left: "22.3%",
  width: "54.2%",
  maxHeight: "309px",
  transform: "translateY(-63.6%)",
};

const labelCanvasSmall = {
  ...labelCanvas,
  width: "54.4%",
  maxHeight: "181px",
  transform: "translateY(-64.5%)"
};


export default {
  bottleContainer,
  bottle,
  total,
  price,
  zoomIn,
  zoomOut,
  pinchIcon,
  labelImageWrapper,
  labelImage,
  labelCanvas,
  labelCanvasSmall
};



// WEBPACK FOOTER //
// ./src/styles/label.js